<template>
  <li class="search-results-item" @click="goTo">
    <div class="search-results-item__link">
      <template v-if="item.type === 'OwnContract'">
        <div class="search-results-item__header">
          <div class="search-results-item__title ms-small-head">
            {{ item.code }}. {{ item.name }}
          </div>
          <div class="search-results-item__type ms-help">
            {{ types[item.type] }}
          </div>
        </div>
        <div class="search-results-item__info ms-help">
          Заказчик: {{ item.customer_name }}
        </div>
      </template>
      <template v-else-if="item.type === 'ContragentContract'">
        <div class="search-results-item__header">
          <div class="search-results-item__title ms-small-head">
            {{ item.performer_name }}
          </div>
          <div class="search-results-item__type ms-help">
            {{ types[item.type] }}
          </div>
        </div>
        <div class="search-results-item__info ms-text">
          {{ item.main_contract_code }}. {{ item.main_contract_name }}
        </div>
        <div class="search-results-item__additional ms-help">
          Этап: {{ item.roadmap_name }}
        </div>
      </template>
      <template v-else-if="item.type === 'Materials'">
        <div class="search-results-item__header">
          <div class="search-results-item__title ms-small-head">
            {{ item.resource_file_name }}
          </div>
          <div class="search-results-item__type ms-help">
            {{ types[item.type] }}
          </div>
        </div>
        <div class="search-results-item__info ms-text">
          {{ item.file_type_category }} ({{ item.file_type_name }})
        </div>
      </template>
    </div>
  </li>
</template>

<script>
const types = {
  OwnContract: 'Проект',
  ContragentContract: 'Подрядчик',
  Materials: 'Материалы'
}

export default {
  props: ['item'],
  data () {
    return {
      types
    }
  },
  methods: {
    getUrl () {
      switch (this.item.type) {
        case 'OwnContract':
          return `/app/contracts/${this.item.id}`
        case 'ContragentContract':
          return `/app/contragents/${this.item.id}`
        case 'Materials':
          return `/app/contracts/${this.item.contract_id}/resources`
      }
    },
    goTo () {
      const route = this.$router.resolve({
        path: this.getUrl()
      })

      window.open(route.href, '_blank')
    }
  }
}
</script>

<style lang="less">
.search-results-item {
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: rgba(@primary-color, 0.1);
  }

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__type {
    margin-left: 16px;
  }

  &__info {
    margin-top: 4px;
  }

  &__additional {
    margin-top: 4px;
    font-size: 11px;
  }
}
</style>
